import { unknownErrorMessage } from './errors'

type SentryExceptionLike = {
  value?: string
}

export type SentryEventLike = {
  message?: string
  exception?: {
    values?: SentryExceptionLike[]
  }
  contexts?: {
    [key: string]: unknown
    browser?: {
      name?: string
    }
  }
  request?: {
    headers?: Record<string, string>
  }
}

export type SentryHintLike = {
  originalException?: unknown
}

export function sentryExceptionMessages(event: SentryEventLike): string {
  return event.exception?.values
    ?.map((value) => value.value)
    .filter((value): value is string => Boolean(value))
    .join('\n') || ''
}

function isInstagramInAppBrowser(event: SentryEventLike): boolean {
  const browserName = event.contexts?.browser?.name || ''
  const headers = event.request?.headers || {}
  const userAgent = headers['User-Agent'] || headers['user-agent'] || ''

  return browserName === 'Instagram' || userAgent.includes('Instagram')
}

function isHandlingDisabledMessage(value: unknown): boolean {
  const message = unknownErrorMessage(value, '')
  return /\bHandling is disabled\b/.test(message)
}

function isRuntimeSendMessageTabNotFoundMessage(value: unknown): boolean {
  const message = unknownErrorMessage(value, '')
  return /\bInvalid call to runtime\.sendMessage\(\)\. Tab not found\./.test(message)
}

export function isInstagramHandlingDisabledRejection(
  event: SentryEventLike,
  hint?: SentryHintLike,
): boolean {
  if (!isInstagramInAppBrowser(event)) return false

  return [
    hint?.originalException,
    event.message,
    sentryExceptionMessages(event),
  ].some(isHandlingDisabledMessage)
}

export function isRuntimeSendMessageTabNotFoundRejection(
  event: SentryEventLike,
  hint?: SentryHintLike,
): boolean {
  return [
    hint?.originalException,
    event.message,
    sentryExceptionMessages(event),
  ].some(isRuntimeSendMessageTabNotFoundMessage)
}
